import * as React from 'react';
import * as styles from './styles.css';

export interface IFaqItem {
  question: string;
  answer: string;
}

export interface IFaqSectionProps {
  items: IFaqItem[];
  isOpen: (index: number) => boolean;
  onToggle: (index: number) => void;
}

export const FaqSection: React.FC<IFaqSectionProps> = ({ items, isOpen, onToggle }) => (
  <section className={styles['faq-section']} aria-label="Вопросы и ответы">
    <div className={styles['faq']}>
      <h2 className={`${styles['faq__title']} text-primary`}>Вопросы и ответы</h2>
      <div className={styles['faq-accordion']}>
        {items.map((item, index) => (
          <div key={item.question} className={`${styles['accordion__item']} ${isOpen(index) ? 'is-open' : ''}`}>
            <button
              className={styles['accordion__toggle']}
              type="button"
              onClick={() => onToggle(index)}
              data-accordion-toggle
            >
              <h4 className={`${styles['accordion__title']} text-primary`}>{item.question}</h4>
            </button>
            <div className={styles['accordion__panel']}>
              <p className="body1 text-primary">{item.answer}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  </section>
);
